// extracted by mini-css-extract-plugin
export var box = "T_vC";
export var btnBase = "T_d1";
export var boxBtn = "T_xL T_d1";
export var btnWrapper = "T_d2";
export var closeBtn = "T_xM T_d1";
export var boxIcon = "T_xN";